/**
 * MediaPlayback Component
 */

import React, { FC } from 'react';
import { MediaPlaybackProps } from './mediaPlayback.types';
import MediaPlaybackDiv from './mediaPlayback.style';

export const MediaPlaybackContainer: FC<MediaPlaybackProps> = ({
  playbackContainerId,
  contentId,
  topicId,
  mediaItem = {},
  initConfig = {},
  playerOptions = {},
  children,
  ...others
}: MediaPlaybackProps) =>
  <MediaPlaybackDiv
    id={playbackContainerId}
    {...others}
  >
    {children}
  </MediaPlaybackDiv>;

export default MediaPlaybackContainer;
